<template>
    <div>
      <b-row>
    <b-col md="12">   
    <b-table
      :ref="refTable"
      
      :items="items"
      :fields="fFields"
      responsive
      :per-page="pPage"
      class="medezTables cutescroll"    
      :show-empty="showMessageIsEmpty"
      :current-page="currentPage"   
      @row-clicked="LocalrowClicked" 
      @row-selected="rowSelected"    
      @row-dblclicked="ondblClicked"              
      :tbody-tr-class="tbodyRowClass"
      :id="refTable"
      :tbody-tr-attr="tbodyRowAttr"
      :sort-compare="Compare"
      :empty-text="$t('MdTable.nRecShow')"
    >


     <template v-if="editIconEvent || deleteIconEvent || viewIconEvent || otherIconEvent || iconSelected && this.items.length > 0" #cell(actions)="row">              

        <b-tooltip v-if="viewIconEvent" :target="'ViewIcon-'+row.index"  placement="top" :delay="{ show: 1500, hide: 50 }">
          {{hintViewIcon ? hintViewIcon : $t('Shared.View')}}
        </b-tooltip>
         <b-tooltip v-if="otherIconEvent" :target="'PrintIcon-'+row.index"  placement="top" :delay="{ show: 1500, hide: 50 }">
            {{otherIcon === 'printer-fill' ? $t('Shared.Report') : 'Other Icon' }}
          </b-tooltip>
        <b-icon v-if="editIconEvent && isReadOnly && VisibleEditIcon"  icon="eye-fill" @click="editButton(row.item)" v-b-tooltip.hover.top="$t('Shared.Edit')" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.8" variant="light"></b-icon>
       


           
       <span v-if="iconSelected && !isReadOnly" :class="row.item.selected ? 'rounded-circle tableActionBTN tableBTNtext ikon med-status-complete checkboxBTNChecked' : 'rounded-circle tableActionBTN tableBTNtext ikon med-status-complete checkboxBTN'"></span>
      <!--<span v-if="iconSelected && !isReadOnly" class="rounded-circle tableActionBTN tableBTNtext ikon med-status-complete checkboxBTNChecked"></span>--> 
      
       
       <!--<b-icon v-if="editIconEvent && !isReadOnly && VisibleEditIcon" icon="pencil-fill" @click="editButton(row.item)" v-b-tooltip.hover.top="$t('Shared.Edit')" class="rounded-circle tableActionBTN" scale=".5" font-scale="1.8" variant="light"></b-icon>-->
        <span v-b-tooltip.hover.top="$t('Shared.Edit')" btn="EditIcon" v-if="editIconEvent && !isReadOnly && VisibleEditIcon" :class="'rounded-circle tableActionBTN tableBTNtext ikon med-pen'" @click="editButton(row.item)"></span>
      
      
        <b-icon v-if="emailIconEvent && !isReadOnly" icon="share-fill" @click="emailButton(row.item)" v-b-tooltip.hover.top="$t('Shared.Email')" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.8" variant="light"></b-icon>
        <!--<b-icon v-if="deleteIconEvent && !isReadOnly && VisibleDeleteIcon"  icon="trash-fill" @click="deleteButton(row.item)" v-b-tooltip.hover.top="$t('Shared.Delete')" class="rounded-circle tableActionBTN-danger ml-2" scale=".5" font-scale="1.8" variant="light"></b-icon>-->
       <span v-b-tooltip.hover.top="$t('Shared.Delete')" v-if="deleteIconEvent && !isReadOnly && VisibleDeleteIcon" :class="'rounded-circle tableActionBTN tableBTNtext ikon med-bin'" @click="deleteButton(row.item)"></span>
       

       <!-- <b-icon :id="'ViewIcon-'+row.index" v-if="viewIconEvent" icon="play-fill" @click="viewButton(row.item, $event.target)" :class="isMedicationInbox && row.item.allowToReceive == false ? 'rounded-circle tableActionBTN mr-2 iconDisabled btndisabled':'rounded-circle tableActionBTN mr-2'" scale=".5" font-scale="1.8" variant="light"></b-icon>-->
        <span :id="'ViewIcon-'+row.index" btn="ViewIcon" v-if="viewIconEvent" @click="viewButton(row.item, /*row.index*/ $event)" :class="isMedicationInbox && row.item.allowToReceive == false ? 'rounded-circle tableActionBTN tableBTNtext ikon med-play-mini iconDisabled btndisabled':'rounded-circle tableActionBTN tableBTNtext ikon med-play-mini'"></span>
       
       
       
       
        <b-icon v-if="Warning && row.item.warningList.length > 0" id="tWarning" icon="exclamation-triangle-fill" @click="WarningLocal(row.item, $event.target)" class="rounded-circle tableActionBTN ml-2" scale=".5" font-scale="1.8" variant="light"></b-icon>
        <b-icon v-if="Error && row.item.errorList.length > 0" id="tError" icon="wrench" @click="ErrorLocal(row.item, $event.target)" class="rounded-circle tableActionBTN ml-2" scale=".5" font-scale="1.8" variant="light"></b-icon>
       
       
       <!-- <b-icon v-if="otherIconEvent" :icon="otherIcon" @click="otherButton(row.item, $event.target)" v-b-tooltip.hover.top="$t('Shared.Report')" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.8" variant="light"></b-icon> -->                    
       <span :id="'PrintIcon-'+row.index"  v-if="otherIconEvent" :icon="otherIcon" @click="otherButton(row.item, $event.target)" class="rounded-circle tableActionBTN tableBTNtext ikon med-print"></span>
       
        <a :href=row.item.zoomStartURL target="_blank" class="dashLink dashURL">
          <b-icon v-if="showTeleHealthIcon && row.item.zoomStartURL != null" icon="box-arrow-up-right" v-b-tooltip.hover.top="$t('schedule-editor.sMeetingNow')" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.8" variant="light"></b-icon>
        </a>
        
     </template>

    <template v-if="IsInsurancePrior" #cell(status)="row" class="dateNotes">            
      <div>
        <span v-if="row.item.status === 'Active'" class="DocumentExpired">{{$t('Shared.Active')}}</span>
        <span v-else>{{ $t('Shared.Inactive') }}</span>
      </div>     
    </template>
  
     <template v-if="this.isSchedulerDB" #cell(startDate)="row" class="dateNotes">            
        {{row.item.startDate}}
          <div>
            <div class="pushItDown" v-if="row.item.status === 'Showed Up'"></div>
            <div v-bind:class="row.item.status === 'Showed Up'  ? 'chRstatusfinished completeDraft':'chRstatus mt-2'">
              {{row.item.status}}
            </div>
          </div>
     </template>

     <template v-if="this.isMedicationInbox" #cell(issuedDate)="row" class="dateNotes">            
      {{row.item.issuedDate}}
        <div class="pushItDown" v-if="row.item.status === 'RECEIVED'"></div>
          <div v-bind:class="row.item.status === 'RECEIVED' ? 'chRstatusfinished':'chRstatus mt-2'">
            {{$t('BadgeStatusIn.'+row.item.status)}}
          </div>
     </template>  

     <template  #cell(isUploaded)="row">            
                <!-- Tabla de Admission -->
                  <div v-if="IsDCSUpload">
                    <span v-if="row.item.isUploaded === 'Y' || row.item.isUploaded === true" class="DocumentExpired">
                      {{ $t('Uploaded') }}
                    </span>
                    <span v-else-if="row.item.isUploaded === 'F'" class="DocumentExpired" style="background-color: red; color: white !important;">{{ $t('Failed') }}</span>
                  </div>
      </template>

    </b-table>
        <b-row>
      <b-col v-if="pageOptions" sm="7" md="6" class="my-1">
        <b-pagination 
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="pPage"
          align="fill"
          size="sm"
          class="my-0"
          @change="fpageChanged"
        ></b-pagination>
      </b-col>
      <b-col v-if="pageOptions" align="right" class="mr-2">
          <b-form-group
            >{{ $t('Shared.Show') }}
              <b-form-select
                v-model="pPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
                style="width:auto;"
                @change="pageFunction($event)"
              ></b-form-select>
              {{ $t('Shared.Of') }} {{totalRows}}
            </b-form-group>
        </b-col>
      </b-row>
        </b-col>
      </b-row>
    </div>
   

  
</template>

<script>

import { EventBus } from '../../../event-bus.js';
import Utils from '@/common/utils'
import moment from 'moment'

export default {
  name: 'MdTablePaginationClient',
   props: {
     fields:Array,    
     items:  Array, 
     perPageFunction: Function,
     perPage: Number,
     pageChanged: Function,   
     totalRows:Number,  
     onRowSelected: Function, 
     editIconEvent: Function,
     deleteIconEvent: Function, 
     ShowDetails:Boolean,
     showMessageIsEmpty:Boolean,
     otherIconEvent: Function,
     otherIcon: String,
     viewIconEvent: Function,
     Error: Function,
     Warning: Function,
     refTable: String,
     RowClick:Function,   
     isReadOnly:Boolean,
     IsInsurancePrior:Boolean,
     VisibleDeleteIcon:Boolean,
     VisibleDownloadIcon:Boolean,
     VisibleViewIcon:Boolean,
     VisibleEditIcon:Boolean,
     tbodyRowAttr: Function,
     isSchedulerDB:[Boolean],
     IsDCSUpload: [Boolean],
     FieldsDate:Array,
     ondblClick:Function,
     emailIconEvent: Function,
     showTeleHealthIcon: Boolean,
     hintViewIcon:String,
     isMedicationInbox: Boolean,
     iconSelected:Function
   },
    mixins: [EventBus],
  data(){
    return{  
        pageOptions: [5,10,15,20,30,40,50],
        //perPage: 10,
        pPage: this.perPage,
        itemlocal:this.items,
        cPage:1,
        currentPage: 1, 
         fFields: this.fields,      
    }
  },

  methods: {

    emailButton(row) {
      this.emailIconEvent(row);
    },

    Compare(itemA, itemB, key) {
      if(this.FieldsDate !== undefined && this.FieldsDate !== null){
        if(!this.FieldsDate.includes(key)){
          return false;
        } else {  
          let a = (itemA[key] === null || itemA[key] === ""?'00/00/0000 00:00:00':itemA[key]);
          let b = (itemB[key] === null || itemA[key] === ""?'00/00/0000 00:00:00':itemB[key]); 
          const dateA = new Date(moment(Utils.formatterDate(a, Utils.getFullDateTimeFormat())).format('MM/DD/YYYY HH:mm:ss')) 
          const dateB = new Date(moment(Utils.formatterDate(b, Utils.getFullDateTimeFormat())).format('MM/DD/YYYY HH:mm:ss'))
          return dateA - dateB;
        }
      }
    },

    tbodyRowClass(item) { 
      if(item != null){
         if(item.selected){
          return ["b-table-row-selected", "table-active", "cursor-pointer"]
        } else {
          return ["cursor-pointer"]
        }
      }
      },
      
    rowSelected(items) {     
      this.onRowSelected(items);
    },

    LocalrowClicked(item, index, event){
      this.RowClick(item,index,event);
    },

    viewButton(row,e) {      
      this.viewIconEvent(row,e);
      EventBus.$emit('shwoHideFavorite', false);
      EventBus.$emit('onUpdatedMenu', '');
    },

    ErrorLocal(row){
      this.Error(row);
    },

    WarningLocal(row){
      this.Warning(row);
    },


     editButton(row) {
        this.editIconEvent(row);
    },

    deleteButton(row) {
        this.deleteIconEvent(row);
    },
    selectRow(index){
      this.onSelectRow(index);
    },

    selectRow2(row) {
      this.$refs[this.refTable].selectRow(row)
    },
     
    unselectRow2(row) {
      this.$refs[this.refTable].unselectRow(row)
    },

    filtered(filteredItems) {
        this.onFiltered(filteredItems);
    },

    fpageChanged(page) {
        this.pageChanged(page);
    },
     fpageChangedSubItems(page) {
        this.pageChangedSubItems(page);
    },
    pageFunction(perpage) {
        this.perPageFunction(perpage);
    },
    otherButton(row) {
      this.otherIconEvent(row);
    },

    ondblClicked(item){    
        if (this.ondblClick) {
            this.ondblClick(item);
        } else if (this.viewIconEvent) {
            this.viewButton(item);
        } else if (this.editIconEvent) {
            this.editButton(item);
        }
    }

    },
  created() { 
     //this.fFields.unshift({ key: 'show_details'}); 
    if(this.editIconEvent || this.deleteIconEvent || this.viewIconEvent || this.otherIconEvent || this.emailIconEvent || this.iconSelected) {     
      if(!this.isReadOnly){
        this.fFields.unshift({ key: 'actions', label: this.$tc('Shared.ActionsTxt',2)});
      }      
    }

    EventBus.$on("rowWasClicked", function (e) { 
      this.tbodyRowClass(e);      
     }.bind(this));
  }
}
</script>

<style scoped>

.checkboxBTN{
  background-color: #FFF  !important;
  border: 1px dashed #19BEE1 !important;
}

.checkboxBTN:hover{
  background-color: #19BEE1  !important;
  border: 1px dashed #FFF !important;
}

.checkboxBTN::before{
  color: #19BEE1;
  opacity: 0.5;
}
.checkboxBTN:hover::before{
  opacity: 1;
  color: #FFF;
}

.checkboxBTNChecked{
  background-color: #87e819 !important;
  border: 1px solid #FFF !important;
  font-weight: bold;
}

.checkboxBTNChecked:hover{
  background-color: #07ce00 !important;
}


</style>

